// Reconstructed from the supplied production build; original component names were unavailable.
const Button = ({
  children: a,
  type: n = "button",
  variant: i = "primary",
  fullWidth: l = false,
  onClick: c,
  disabled: u = false,
  className: m = "",
}) => {
  const f =
      "px-4 py-2 rounded-md text-white font-medium transition duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2",
    x = {
      primary: "bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500",
      secondary: "bg-cyan-500 hover:bg-cyan-600 focus:ring-cyan-400",
      success: "bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500",
      warning: "bg-amber-500 hover:bg-amber-600 focus:ring-amber-400",
      error: "bg-red-600 hover:bg-red-700 focus:ring-red-500",
      ghost: "bg-transparent text-indigo-600 hover:bg-gray-100",
    },
    p = l ? "w-full" : "",
    g = u ? "opacity-50 cursor-not-allowed" : "cursor-pointer";
  return (
    <button type={n} onClick={c} disabled={u} className={`${f} ${x[i]} ${p} ${g} ${m}`}>
      {a}
    </button>
  );
};
export { Button };
